import { customFor, termOf, useMediaVersion } from './media';

export default function FaceText({ text }: { text: string }) {
  useMediaVersion();
  const image = customFor(text)?.image;
  if (!image) return <>{text}</>;
  return (
    <span className="face-text">
      <img className="custom-pic g-tile-img" src={image} alt="" aria-hidden="true" draggable={false} />
      <span>{termOf(text)}</span>
    </span>
  );
}
